module.exports = __webpack_public_path__ + "img/t5-18.90463d87.svg";